import React, { useEffect, useState } from 'react';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Box, Button, Chip, Grid, ListSubheader } from '@material-ui/core'



import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import clsx from 'clsx';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import ViewListIcon from '@material-ui/icons/ViewList';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import SearchIcon from '@mui/icons-material/Search';
import BackupIcon from '@mui/icons-material/Backup';

import avatar from '../../assets/img/avatar.png';

import {
    selectUsuarioSeleccionado,
} from "../../redux/reducer/loginReducer";

import {
    Link,
} from 'react-router-dom';

import { PRIMARY_COLOR } from '../../constants/colores'
import { useHistory } from "react-router-dom";
import { getAvisosSeguimientoUsuario, getAvisosUsuario } from '../../services/alumnos';
import DialogModalSearch from './DialogModalSearch';
import CrmIcon from '../../assets/icons/CrmIcon';
import NotasExamenesIcon from '../../assets/icons/NotasExamenesIcon';
import SeguimientoComercialIcon from '../../assets/icons/SeguimientoComercialIcon';
import AsignacionMasivaIcon from '../../assets/icons/AsignacionMasivaIcon';
import AlumnosRegistradosIcon from '../../assets/icons/AlumnosRegistradosIcon';
import AccesosTuteaIcon from '../../assets/icons/AccesosTuteaIcon';
import AlumnosBajaIcon from '../../assets/icons/AlumnosBajaIcon';
import AlumnosPosiblesBajaIcon from '../../assets/icons/AlumnosPosiblesBajaIcon';
import AlumnosInteraccionIcon from '../../assets/icons/AlumnosInteraccionIcon';
import ExposicionesOralesIcon from '../../assets/icons/ExposicionesOralesIcon';
import TagsIcon from '../../assets/icons/TagsIcon';
import FacturasAlumnosIcon from '../../assets/icons/FacturasAlumnosIcon';
import AnaliticaIcon from '../../assets/icons/AnaliticaIcon';
import PrevisionCuotasIcon from '../../assets/icons/PrevisionCuotasIcon';
import TutoresIcon from '../../assets/icons/TutoresIcon';
import MscontaIcon from '../../assets/icons/MscontaIcon';
import EstadisticasIcon from '../../assets/icons/EstadisticasIcon';
import VerifactuIcon from '../../assets/icons/VerifactuIcon';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    appbar: {
        backgroundColor: PRIMARY_COLOR,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        textAlign: 'center',
        lineHeight: '50px'
    },
    avatar: {
        width: 250,
    },
    list: {
        width: 250,
        marginTop: 10
    },
    fullList: {
        width: 'auto',
    },
}));


const NavbarTop = (props) => {
    const { title = null, showBack } = props

    const classes = useStyles();

    const [avisos, setAvisos] = useState([]);
    const [avisosSeguimiento, setAvisosSeguimiento] = useState([]);

    // --------------------------------------------------------------
    // handleAbrirSidebar
    //
    // Permite abrir y cerrar la sidebar
    // --------------------------------------------------------------
    // const dispatch = useDispatch();

    // --------------------------------------------------------------
    // Usuario seleccionado
    // --------------------------------------------------------------
    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });

    // const preventDefault = (event) => event.preventDefault();

    /* -------------------------------- useEffect ------------------------------- */
    useEffect(() => {

        const usuario_id = usuarioSeleccionado.id

        getAvisosUsuario({usuario_id}).then ( (response) => {
            response && setAvisos(response.avisos)
            // console.log(response)
        })
        getAvisosSeguimientoUsuario({usuario_id}).then ( (response) => {
            response && setAvisosSeguimiento(response.avisos)
            // console.log(response)
        })

    }, [])

    /* ---------------------------------- state --------------------------------- */
    const [state, setState] = React.useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });

    const anchor = 'left';

    /* ------------------------------ toggleDrawer ------------------------------ */
    const toggleDrawer = (anchor, open) => (event) => {
        if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    /* ---------------------------------- list ---------------------------------- */
    const list = (anchor) => (
      <div
        className={clsx(classes.list, {
          [classes.fullList]: anchor === "top" || anchor === "bottom",
        })}
        role="presentation"
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        

        {/* Administrador: perfil_id = 1 */}
        {usuarioSeleccionado.perfil_id === "1" && (
          <>
            <ListItem button component={Link} to="/home">
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Panel de control" />
            </ListItem>

            <ListSubheader>ALUMNOS</ListSubheader>

            <ListItem button component={Link} to="/alumnos">
              <ListItemIcon>
                <CrmIcon />
              </ListItemIcon>
              <ListItemText primary="CRM" />
            </ListItem>
            <ListItem button component={Link} to="/alumnos_notas">
              <ListItemIcon>
                <NotasExamenesIcon />
              </ListItemIcon>
              <ListItemText primary="Notas exámenes" />
            </ListItem>
            <ListItem button component={Link} to="/alumnos_productos_seguimiento">
              <ListItemIcon>
                <SeguimientoComercialIcon />
              </ListItemIcon>
              <ListItemText primary="Seguimiento comercial" />
            </ListItem>

            {/* <ListItem button component={Link} to="/buscar_alumno" >
                    <ListItemIcon><ManageSearchIcon /></ListItemIcon>
                    <ListItemText primary="Buscar alumno" />
                </ListItem> */}

            <ListItem button component={Link} to="/alumnos_asignacion_masiva">
              <ListItemIcon>
                <AsignacionMasivaIcon />
              </ListItemIcon>
              <ListItemText primary="Asignación masiva" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_reservas">
              <ListItemIcon>
                <AlumnosRegistradosIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Reservas" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_registrados">
              <ListItemIcon>
                <AlumnosRegistradosIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Registrados" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_seguimiento">
              <ListItemIcon>
                <AlumnosRegistradosIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Seguimiento" />
            </ListItem>

            <ListItem button component={Link} to="/accesos_tutea">
              <ListItemIcon>
                <AccesosTuteaIcon />
              </ListItemIcon>
              <ListItemText primary="Accesos Tutea" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_baja">
              <ListItemIcon>
                <AlumnosBajaIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Baja" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_posible_baja">
              <ListItemIcon>
                <AlumnosPosiblesBajaIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Posibles Baja" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_interaccion">
              <ListItemIcon>
                <AlumnosInteraccionIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Interaccion" />
            </ListItem>

            <ListItem button component={Link} to="/exposiciones-orales">
              <ListItemIcon>
                <ExposicionesOralesIcon />
              </ListItemIcon>
              <ListItemText primary="Exposiciones orales" />
            </ListItem>

            <ListItem button component={Link} to="/tags">
              <ListItemIcon>
                <TagsIcon />
              </ListItemIcon>
              <ListItemText primary="Tags" />
            </ListItem>

            <ListItem button component={Link} to="/satisfaccion">
              <ListItemIcon>
                <AnaliticaIcon />
              </ListItemIcon>
              <ListItemText primary="Satisfacción" />
            </ListItem>
            
            <Divider />

            <ListSubheader>ADMINISTRACIÓN</ListSubheader>
            
            <ListItem button component={Link} to="/facturas">
              <ListItemIcon>
                <FacturasAlumnosIcon />
              </ListItemIcon>
              <ListItemText primary="Facturas alumnos" />
            </ListItem>

            <ListItem button component={Link} to="/analitica">
              <ListItemIcon>
                <AnaliticaIcon />
              </ListItemIcon>
              <ListItemText primary="Analitica" />
            </ListItem>

            <ListItem button component={Link} to="/incidencias">
              <ListItemIcon>
                <AnaliticaIcon />
              </ListItemIcon>
              <ListItemText primary="Incidencias" />
            </ListItem>

            <ListSubheader>CUOTAS</ListSubheader>
            <ListItem button component={Link} to="/cuotas">
              <ListItemIcon>
                <PrevisionCuotasIcon />
              </ListItemIcon>
              <ListItemText primary="Previsión de cuotas" />
            </ListItem>

            <ListItem button component={Link} to="/vision_cuotas">
              <ListItemIcon>
                <PrevisionCuotasIcon />
              </ListItemIcon>
              <ListItemText primary="Visión de cuotas" />
            </ListItem>

            <ListSubheader>TUTORES</ListSubheader>
            <ListItem button component={Link} to="/alumnos-distribucion">
              <ListItemIcon>
                <TutoresIcon />
              </ListItemIcon>
              <ListItemText primary="Distribución de alumnos" />
            </ListItem>
            
            <ListItem button component={Link} to="/retencion-tutores">
              <ListItemIcon>
                <TutoresIcon />
              </ListItemIcon>
              <ListItemText primary="Retención Tutores" />
            </ListItem>
            
            <ListItem button component={Link} to="/seguimiento-tutores">
              <ListItemIcon>
                <TutoresIcon />
              </ListItemIcon>
              <ListItemText primary="Seguimiento Tutores" />
            </ListItem>

            <ListItem button component={Link} to="/tutores">
              <ListItemIcon>
                <TutoresIcon />
              </ListItemIcon>
              <ListItemText primary="Tutores" />
            </ListItem>

            <ListItem button component={Link} to="/tutorias_individuales">
              <ListItemIcon>
                <TutoresIcon />
              </ListItemIcon>
              <ListItemText primary="Tutorias individuales" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_gestion_academica">
              <ListItemIcon>
                <AlumnosRegistradosIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos gestión académica" />
            </ListItem>

            <ListItem button component={Link} to="/liquidacion_tutores">
              <ListItemIcon>
                <TutoresIcon />
              </ListItemIcon>
              <ListItemText primary="Liquidación de tutores" />
            </ListItem>

            <ListItem button component={Link} to="/facturacion">
              <ListItemIcon>
                <FacturasAlumnosIcon />
              </ListItemIcon>
              <ListItemText primary="Facturacion creadores" />
            </ListItem>

            <ListSubheader>CONTABILIDAD</ListSubheader>

            <ListItem button component={Link} to="/ms_conta">
              <ListItemIcon>
                <MscontaIcon />
              </ListItemIcon>
              <ListItemText primary="MS Conta" />
            </ListItem>

            <ListItem button component={Link} to="/facturas_verifactu">
              <ListItemIcon>
                <VerifactuIcon />
              </ListItemIcon>
              <ListItemText primary="Verifactu" />
            </ListItem>

            <Divider />
            <ListSubheader>COMERCIALES</ListSubheader>
            <ListItem button component={Link} to="/ringover-llamadas">
              <ListItemIcon>
                <SeguimientoComercialIcon />
              </ListItemIcon>
              <ListItemText primary="Llamadas realizadas" />
            </ListItem>

            <ListItem button component={Link} to="/cmi-comercial">
              <ListItemIcon>
                <EstadisticasIcon />
              </ListItemIcon>
              <ListItemText primary="Indicadores" />
            </ListItem>

            <ListItem button component={Link} to="/antiguos-alumnos">
              <ListItemIcon>
                <EstadisticasIcon />
              </ListItemIcon>
              <ListItemText primary="Antiguos alumnos" />
            </ListItem>
          </>
        )}

        {/* Jefatura de estudios: perfil_id = 13, Administracion: perfil: 12*/}
        {/* {(usuarioSeleccionado.perfil_id === "12" || usuarioSeleccionado.perfil_id === "13") && (
          <>
            <ListSubheader>ADMINISTRACIÓN</ListSubheader>
            <ListItem button component={Link} to="/facturacion">
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary="Facturacion creadores" />
            </ListItem>
            <ListItem button component={Link} to="/alumnos_productos_seguimiento">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Seguimiento comercial" />
            </ListItem>
          </>
        )} */}

        {/* Comercial: perfil_id = 2 */}
        {usuarioSeleccionado.perfil_id === "2" && (
          <>
            <ListItem button component={Link} to="/planificacion-llamadas">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Planificación de llamadas" />
            </ListItem>

            {/* <ListItem button component={Link} to="/home">
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Agenda" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="CRM" />
            </ListItem> */}

            {avisos.length > 0 && (
              <ListItem button component={Link} to="/avisos">
                <ListItemIcon>
                  <PeopleIcon />
                </ListItemIcon>
                <ListItemText primary="Avisos" />
                <Chip color="primary" size="small" label={avisos.length} />
              </ListItem>
            )}

            {avisosSeguimiento.length > 0 && (
              <ListItem button component={Link} to="/avisos_seguimiento">
                <ListItemIcon>
                  <PeopleIcon />
                </ListItemIcon>
                <ListItemText primary="Avisos seguimiento" />
                <Chip
                  color="primary"
                  size="small"
                  label={avisosSeguimiento.length}
                />
              </ListItem>
            )}

            {/* <Divider />
          
            <ListSubheader>ALUMNOS</ListSubheader>

            <ListItem button component={Link} to="/alumnos_registrados">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Registrados" />
            </ListItem>

            <ListItem button component={Link} to="/accesos_tutea">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Accesos Tutea" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_baja">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Baja" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_posible_baja">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Posibles Baja" />
            </ListItem> */}

            {/* <ListItem button component={Link} to="/alumnos_interaccion">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Interaccion" />
            </ListItem> */}
            
            {/* <ListItem button component={Link} to="/alumnos_notas">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Notas exámenes" />
            </ListItem>

            <Divider />
            <ListSubheader>ADMINISTRACIÓN</ListSubheader>

            <ListItem button component={Link} to="/facturas">
              <ListItemIcon>
                <PictureAsPdfIcon />
              </ListItemIcon>
              <ListItemText primary="Facturas de alumnos" />
            </ListItem> */}

            {/* <ListSubheader>CUOTAS</ListSubheader> */}
            {/* <ListItem button component={Link} to="/cuotas">
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary="Previsión de cuotas" />
            </ListItem> */}
            {/* <ListItem button component={Link} to="/vision_cuotas">
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary="Visión de cuotas" />
            </ListItem> */}
          </>
        )}

        {/* Analitica: perfil_id = 3 */}
        {usuarioSeleccionado.perfil_id === "3" && (
          <>
            <ListSubheader>ADMINISTRACIÓN</ListSubheader>
            <ListItem button component={Link} to="/analitica">
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary="Analitica" />
            </ListItem>
          </>
        )}

        {/* Contabilidad: perfil_id = 4 */}
        {usuarioSeleccionado.perfil_id === "4" && (
          <>
            <ListSubheader>CONTABILIDAD</ListSubheader>
            <ListItem button component={Link} to="/ms_conta">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="MS Conta" />
            </ListItem>
            <ListItem button component={Link} to="/facturas_verifactu">
              <ListItemIcon>
                <VerifactuIcon />
              </ListItemIcon>
              <ListItemText primary="Verifactu" />
            </ListItem>
          </>
        )}

        {/* Atencion al alumno (Laura): perfil_id = 12 */}
        {usuarioSeleccionado.perfil_id === "12" && (
          <>
            {/* <ListItem button component={Link} to="/planificacion-llamadas">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Planificación de llamadas" />
            </ListItem> */}

            {/* <ListItem button component={Link} to="/home">
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Agenda" />
            </ListItem> */}

            <ListItem button component={Link} to="/alumnos">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="CRM" />
            </ListItem>

            {avisos.length > 0 && (
              <ListItem button component={Link} to="/avisos">
                <ListItemIcon>
                  <PeopleIcon />
                </ListItemIcon>
                <ListItemText primary="Avisos" />
                <Chip color="primary" size="small" label={avisos.length} />
              </ListItem>
            )}

            <ListItem button component={Link} to="/incidencias">
              <ListItemIcon>
                <AnaliticaIcon />
              </ListItemIcon>
              <ListItemText primary="Incidencias" />
            </ListItem>

            {avisosSeguimiento.length > 0 && (
              <ListItem button component={Link} to="/avisos_seguimiento">
                <ListItemIcon>
                  <PeopleIcon />
                </ListItemIcon>
                <ListItemText primary="Avisos seguimiento" />
                <Chip
                  color="primary"
                  size="small"
                  label={avisosSeguimiento.length}
                />
              </ListItem>
            )}

            <Divider />
          
            <ListSubheader>ALUMNOS</ListSubheader>

            <ListItem button component={Link} to="/alumnos_reservas">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Reservas" />
            </ListItem>
            <ListItem button component={Link} to="/alumnos_registrados">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Registrados" />
            </ListItem>
            {/* <ListItem button component={Link} to="/alumnos_seguimiento">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Seguimiento" />
            </ListItem> */}

            {/* <ListItem button component={Link} to="/accesos_tutea">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Accesos Tutea" />
            </ListItem> */}

            <ListItem button component={Link} to="/alumnos_baja">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Baja" />
            </ListItem>

            <ListItem button component={Link} to="/alumnos_posible_baja">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Posibles Baja" />
            </ListItem>

            {/* <ListItem button component={Link} to="/alumnos_interaccion">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Interaccion" />
            </ListItem> */}
            
            {/* <ListItem button component={Link} to="/alumnos_notas">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Notas exámenes" />
            </ListItem> */}

            <Divider />
            <ListSubheader>ADMINISTRACIÓN</ListSubheader>

            <ListItem button component={Link} to="/facturas">
              <ListItemIcon>
                <PictureAsPdfIcon />
              </ListItemIcon>
              <ListItemText primary="Facturas de alumnos" />
            </ListItem>

            <ListSubheader>CUOTAS</ListSubheader>
            <ListItem button component={Link} to="/cuotas">
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary="Previsión de cuotas" />
            </ListItem> 
            {/* <ListItem button component={Link} to="/vision_cuotas">
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary="Visión de cuotas" />
            </ListItem> */}
            {/* <ListItem button component={Link} to="/alumnos_productos_seguimiento">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Seguimiento comercial" />
            </ListItem> */}

            {/* <Divider />
            <ListSubheader>TUTORIAS</ListSubheader>
            
            <ListItem button component={Link} to="/exposiciones-orales">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Exposiciones orales" />
            </ListItem> */}
          </>
        )}

        {/* Atencion al alumno andalucia: perfil_id = 6 */}
        {usuarioSeleccionado.perfil_id === "6" && (
          <>
            <ListSubheader>ALUMNOS</ListSubheader>
            <ListItem button component={Link} to="/alumnos">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="CRM" />
            </ListItem>
            <ListItem
              button
              component={Link}
              to="/alumnos_registrados_andalucia"
            >
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Registrados" />
            </ListItem>
          </>
        )}

        {/* Marketing: perfil_id = 7 */}
        {usuarioSeleccionado.perfil_id === "7" && (
          <>
            <ListSubheader>ADMINISTRACIÓN</ListSubheader>
            <ListItem button component={Link} to="/alumnos_registrados">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary="Alumnos Registrados" />
            </ListItem>
          </>
        )}

        {/* Control de llamadas: perfil_id = 16 */}
        {usuarioSeleccionado.perfil_id === "16" && (
          <>
            <ListSubheader>RINGOVER</ListSubheader>
            <ListItem button component={Link} to="/ringover-llamadas">
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary="Llamadas realizadas" />
            </ListItem>
            <ListItem button component={Link} to="/ringover-estadisticas">
              <ListItemIcon>
                <ViewListIcon />
              </ListItemIcon>
              <ListItemText primary="Estadísticas" />
            </ListItem>
          </>
        )}

        <Divider />

        <ListItem button component={Link} to="/logout">
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText primary="Salir" />
        </ListItem>
      </div>
    );

    /* ------------------------------ detecta movil ----------------------------- */
    const iOS = process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);
    const [openModalSearch, setOpenModalSearch] = useState(false)

    let history = useHistory();

    const handleGoBack = () => {
      history.goBack();
    };
    /* --------------------------------- return --------------------------------- */
    return (
        <>
            <AppBar position="fixed" className={classes.appbar}>
                <Toolbar>
                    <Grid container>
                        <Grid item>
                            {showBack ?
                                <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={() => handleGoBack()}>
                                    <ArrowBackIosIcon />
                                </IconButton>
                                :
                                <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={toggleDrawer(anchor, true)}>
                                    <MenuIcon />
                                </IconButton>
                            }
                        </Grid>
                        <Grid item style={{flex:1}}>
                          <LogoTutea />
                            {/* <Typography variant="h6" className={classes.title}>
                                {title == null ? '.:: Innovatiio Gestión ::.' : title}
                            </Typography> */}
                        </Grid>
                        <Grid justifyContent='end' item style={{display: 'flex'}}>
                            { 
                            usuarioSeleccionado.perfil_id === '1' ?
                            <a style={{color:'white', paddingTop: 12}} href='https://gestion.innovatiio.com/api/procesos/bak' target='_blank' rel="noreferrer"><BackupIcon /></a>
                            :
                            <></>
                            }
                            <Button onClick={ () => { setOpenModalSearch(true) } }><SearchIcon style={{color: 'white'}} /></Button>
                        </Grid>
                        <Grid item style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>{usuarioSeleccionado.username}</Grid>
                    </Grid>
                    {/* <Button color="inherit" component={Link} to="/logout" onClick={() => { }}>Salir</Button> */}
                </Toolbar>
            </AppBar>

            <React.Fragment key={anchor}>
                <SwipeableDrawer
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}
                    onOpen={toggleDrawer(anchor, true)}
                    disableBackdropTransition={!iOS}
                    disableDiscovery={iOS}
                >
                  
                    <img src={avatar} className={classes.avatar} alt="avatar" />
                    {list(anchor)}
                </SwipeableDrawer>
            </React.Fragment>

            <DialogModalSearch 
                openModalSearch={openModalSearch}
                setOpenModalSearch={setOpenModalSearch}
            />
        </>
    );
}

/* -------------------------------- LogoTutea ------------------------------- */
const LogoTutea = () => {
    return (
      <Box style={{lineHeight: 0, paddingTop: 10}}>
        <svg width="100" height="28" viewBox="0 0 100 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M99.6324 21.7868V27.7479H95.9801C94.5528 27.7479 93.5173 27.454 92.8736 26.8663C92.23 26.2506 91.9081 25.425 91.9081 24.3895V24.2216C91.0965 25.481 90.131 26.4325 89.0115 27.0762C87.8921 27.6919 86.5487 27.9998 84.9815 27.9998C82.5466 27.9998 80.5736 27.454 79.0623 26.3625C77.579 25.2431 76.8374 23.6618 76.8374 21.6188C76.8374 19.24 77.747 17.4069 79.5661 16.1195C81.3852 14.8321 84.0159 14.1884 87.4583 14.1884H90.6487V13.3488C90.6487 12.5932 90.3409 11.9915 89.7252 11.5437C89.1374 11.0679 88.3538 10.8301 87.3743 10.8301C86.4787 10.8301 85.7371 11.026 85.1494 11.4178C84.5896 11.7816 84.2818 12.2854 84.2258 12.929H77.2572C77.4531 10.6621 78.4746 8.91298 80.3217 7.68158C82.1688 6.45017 84.6316 5.83447 87.7101 5.83447C90.9286 5.83447 93.4194 6.50615 95.1825 7.8495C96.9457 9.19285 97.8272 11.1659 97.8272 13.7686V20.4854C97.8272 20.9891 97.9252 21.339 98.1211 21.5349C98.345 21.7028 98.6948 21.7868 99.1706 21.7868H99.6324ZM90.6487 18.6803H87.5842C86.5207 18.6803 85.6811 18.9042 85.0654 19.3519C84.4497 19.7717 84.1419 20.3455 84.1419 21.0731C84.1419 21.6608 84.3518 22.1366 84.7716 22.5004C85.2193 22.8363 85.8071 23.0042 86.5347 23.0042C87.7661 23.0042 88.7456 22.6264 89.4733 21.8707C90.2289 21.0871 90.6207 20.0516 90.6487 18.7642V18.6803Z" fill="#ECB3D0"></path><path d="M51.9541 17.0011C51.9541 14.7342 52.4159 12.7611 53.3394 11.0819C54.291 9.40275 55.6063 8.11537 57.2855 7.2198C58.9927 6.29625 60.9657 5.83447 63.2047 5.83447C65.4995 5.83447 67.5146 6.26826 69.2497 7.13584C71.0129 8.00342 72.3842 9.23483 73.3637 10.8301C74.3433 12.3973 74.833 14.2164 74.833 16.2874C74.833 17.183 74.7631 17.9666 74.6231 18.6383H59.5104V18.7222C59.8743 21.4089 61.2736 22.7523 63.7084 22.7523C65.7794 22.7523 67.0248 21.9547 67.4446 20.3594H74.5812C74.3853 21.7588 73.8395 23.0461 72.9439 24.2216C72.0764 25.369 70.8869 26.2926 69.3757 26.9922C67.8924 27.6639 66.1712 27.9998 64.2122 27.9998C61.6654 27.9998 59.4685 27.552 57.6214 26.6564C55.7743 25.7608 54.3609 24.4875 53.3814 22.8363C52.4299 21.185 51.9541 19.24 51.9541 17.0011ZM67.6545 14.1884C67.4586 13.1529 66.9968 12.3693 66.2692 11.8376C65.5695 11.2778 64.6739 10.998 63.5825 10.998C62.463 10.998 61.5535 11.2778 60.8538 11.8376C60.1821 12.3693 59.7623 13.1529 59.5944 14.1884H67.6545Z" fill="#ECB3D0"></path><path d="M38.6001 12.0902L38.6001 10.8167L38.6001 8.78772V6.08706V0H45.8626V6.08706H50.5223V12.0902H45.8626V19.7724C45.8626 20.4721 46.0165 20.9759 46.3244 21.2837C46.6322 21.5916 47.136 21.7455 47.8356 21.7455H50.5223V27.7486H45.1069C43.036 27.7486 41.4267 27.2028 40.2793 26.1114C39.1598 24.9919 38.6001 23.3687 38.6001 21.2417V12.0902Z" fill="#ECB3D0"></path><path d="M35.8085 6.08691V27.7484H28.7979V25.2716C28.0142 26.1672 27.1327 26.8529 26.1531 27.3286C25.2016 27.7764 24.0262 28.0003 22.6268 28.0003C20.136 28.0003 18.079 27.2307 16.4558 25.6914C14.8326 24.1242 14.021 21.4515 14.021 17.6733V6.08691H21.2835V16.6658C21.2835 18.5129 21.5494 19.8842 22.0811 20.7798C22.6128 21.6754 23.4944 22.1232 24.7258 22.1232C25.9292 22.1232 26.8668 21.6614 27.5385 20.7378C28.2101 19.7863 28.546 18.4289 28.546 16.6658V6.08691H35.8085Z" fill="#ECB3D0"></path><path d="M0 12.0902V9.76725L2.77576e-05 7.66826L0 6.08706V0H7.26249V6.08706H11.9222V12.0902H7.26249V19.7724C7.26249 20.4721 7.41641 20.9759 7.72426 21.2837C8.03211 21.5916 8.53587 21.7455 9.23553 21.7455H11.9222V27.7486H6.50685C4.43585 27.7486 2.82663 27.2028 1.67919 26.1114C0.559729 24.9919 0 23.3687 0 21.2417V12.0902Z" fill="#ECB3D0"></path></svg>
      </Box>
    )
}
export default NavbarTop;